import React from "react";
import { Link } from "@reach/router";
import AppContent from "js/components/AppContent";
import HappyHour from "js/components/pages/CheckoutPage/DropOffDetailsV2/HappyHour";
import PageComponent from "js/components/pages/PageComponent";
import ItemsList from "js/components/pages/PspItemsPage/ItemsList";
import { makeRequest, navigate, url } from "js/services/Network";
import PartnerSellerPageState from "js/stores/pages/PartnerSellerPageState";
import { pick } from "lodash";
import { observer } from 'mobx-react';
import BottomScrollListener from "react-bottom-scroll-listener";
import { Spring } from "react-spring";
import ReferralBanner from "./ReferralBanner";

const offset = '0.25rem';

@observer
export default class PartnerSellerPage extends PageComponent {
  pageName = 'PartnerSellerPage';
  trackingName = 'SP_partner_seller_checkout';
  loginRequired = false;
  timerId = null;

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      readMore: true,
      media: 'Instagram',
      errorMessage: null,
      pspData: {},
      tooltipOpen: false,
      clicked: false,
      approvalStatus: 0,
      sellerId: null
    };
    this.page = PartnerSellerPageState.create({
      micro_store: this.props.alias,
    });
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  copyUrl = () => {
    navigator.clipboard.writeText(this.page.micro_store);
    this.setState({ clicked: true });

    if (this.timerId) {
      clearTimeout(this.timerId);
    }

    setTimeout(() => {
      this.setState({ clicked: false });
    }, 5000);
  };

  bootstrap = () => this.page.load().then(() => {/*analytics.page('My Items Page')*/ });

  redirect = (link, props, params) => navigate(url(link, props, params));

  pageEvent = async () => {
    const url = window.location.href;
    const urlParts = url.split('/');
    const alias = urlParts[urlParts.length - 1];

    try {
      const response = await makeRequest(
        'seller-partner-data',
        { alias: alias },
        pick(this.page, ['page', 'count'])
      );
      this.state.pspData = response.data;
      this.setState({ pspData: response.data })
      if (response.data.psp_data && response.data.psp_data.approval_status) {
        this.setState({ approvalStatus: parseInt(response.data.psp_data.approval_status) });
      }
      if (response.data.psp_data) {
        localStorage.setItem('PSP_SELLER_ALIAS', response.data.psp_data ? response.data.psp_data.seller_id : null)
        localStorage.setItem('PSP_PRINCIPAL_ID', response.data.psp_data ? response.data.psp_data.seller_id : null);
      }
    } catch (error) {
      this.state.errorMessage = error;
      throw error;
    }

  }

  buttonCTA = (cta, link) => {
    localStorage.setItem('ALIAS', this.props.alias);
    this.redirect(link, { alias: this.state.pspData.micro_store }, '');
  }

  learnMore = (link) => {
    localStorage.setItem('ALIAS', this.props.alias);
    this.redirect(link, '', '')
  }

  renderPage() {
    const page = this.page;
    localStorage.setItem("STORE_CURRENCY", page.seller_country)

    return (
      <>
        {page.happy_hour === 1 && <HappyHour start_date={page.happy_hour_start_time} start_hour={18} />}

        <ReferralBanner />

        <AppContent className="new-pod-ui seller-items-page tw-bg-white" padded>
          <div className="pod-container tw-mt-8 tw-pr-5 tw-pl-5">

            <div className="tw-mt-12 tw-mb-8 tw-flex tw-items-center tw-justify-between md:tw-hidden">
              <div>
                <span className="tw-font-semibold">Sell on POD</span><br />
                <Link to={'/psp-seller-learn-more'} onClick={() => this.setState({ readMore: !this.state.readMore })} className="tw-text-primary tw-underline">Learn more</Link>
              </div>

              <button className="tw-bg-secondary tw-rounded-lg tw-border tw-border-white tw-py-2 tw-px-4 tw-gap-2 tw-text-white tw-flex-end"
                onClick={(cta) => this.buttonCTA(cta, '/psp-onboard-signup')}>
                Start selling
                <img
                  src="/images/icons/right.svg"
                  alt="shop"
                  className="size-24px"
                />
              </button>
            </div>

            <div className="tw-grid md:tw-grid-cols-5 tw-gap-4 md:tw-gap-8">
              <div className="store-container md:tw-col-span-3">
                <h3 className="tw-text-primary">
                  Shop {this.state.pspData ? this.state.pspData.micro_store : 'Someone\'s'}
                </h3>

                {this.state.approvalStatus === 1 ? (
                  <p className="tw-text-sm tw-text-pretty tw-mb-0 tw-text-secondary">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16.9658 7.94948L15.8324 6.63281C15.6158 6.38281 15.4408 5.91615 15.4408 5.58281V4.16615C15.4408 3.28281 14.7158 2.55781 13.8324 2.55781H12.4158C12.0908 2.55781 11.6158 2.38281 11.3658 2.16615L10.0491 1.03281C9.47409 0.541146 8.53242 0.541146 7.94909 1.03281L6.64076 2.17448C6.39076 2.38281 5.91576 2.55781 5.59075 2.55781H4.14909C3.26576 2.55781 2.54076 3.28281 2.54076 4.16615V5.59115C2.54076 5.91615 2.36576 6.38281 2.15742 6.63281L1.03242 7.95781C0.549089 8.53281 0.549089 9.46615 1.03242 10.0411L2.15742 11.3661C2.36576 11.6161 2.54076 12.0828 2.54076 12.4078V13.8328C2.54076 14.7161 3.26576 15.4411 4.14909 15.4411H5.59075C5.91576 15.4411 6.39076 15.6161 6.64076 15.8328L7.95742 16.9661C8.53242 17.4578 9.47409 17.4578 10.0574 16.9661L11.3741 15.8328C11.6241 15.6161 12.0908 15.4411 12.4241 15.4411H13.8408C14.7241 15.4411 15.4491 14.7161 15.4491 13.8328V12.4161C15.4491 12.0911 15.6241 11.6161 15.8408 11.3661L16.9741 10.0495C17.4574 9.47448 17.4574 8.52448 16.9658 7.94948ZM12.4658 7.42448L8.44076 11.4495C8.32409 11.5661 8.16576 11.6328 7.99909 11.6328C7.83242 11.6328 7.67409 11.5661 7.55742 11.4495L5.54076 9.43281C5.29909 9.19115 5.29909 8.79115 5.54076 8.54948C5.78242 8.30781 6.18242 8.30781 6.42409 8.54948L7.99909 10.1245L11.5824 6.54115C11.8241 6.29948 12.2241 6.29948 12.4658 6.54115C12.7074 6.78281 12.7074 7.18281 12.4658 7.42448Z" fill="#6D60F6" />
                    </svg>
                    Verified POD partner seller{"  "} <Link to={'#'} onClick={() => this.setState({ readMore: !this.state.readMore })} className="tw-text-primary tw-underline tw-invisible md:tw-visible">Learn more</Link>
                  </p>
                ) : null}

                <div className="tw-mt-12 tw-mb-4 tw-flex tw-items-center tw-justify-between">
                  <h6 className="tw-font-semibold">All products</h6>
                  <p>{page.items.length} out of {page.total_item_count}</p>
                </div>

                <div className="">
                  {page.items.length ? (
                    <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }} style={{ backgroundColor: 'white !important' }}>
                      {animation => <ItemsList style={animation} endpoint='checkout-page' addButton={false} />}
                    </Spring>
                  ) : <div className="seller-no-items">
                    <h2>{page.seller_name} has no items for sale yet.</h2>
                  </div>}
                  <BottomScrollListener onBottom={page.loadMore} />
                </div>
              </div>

              <div className="added-item tw-hidden md:tw-block md:tw-col-span-2">
                {this.state.readMore ? (
                  <div className="carded tw-bg-primary tw-max-h-[90vh] tw-mb-16 tw-md:tw-mb-0 tw-text-white tw-rounded-3xl tw-overflow-hidden tw-relative">
                    <div className="tw-bg-[#FDAE09] size-55px tw-rounded-full tw-absolute tw--top-10 tw-right-3 tw-hidden tw-md:tw-block"></div>
                    <div className="tw-md:tw-flex tw-my-6 tw-px-10 tw-hidden">
                      <span className="tw-block tw-bg-[#FDAE09] size-8px tw-rounded-full"></span>
                    </div>

                    <div className="tw-md:tw-px-12 tw-px-6 tw-py-8">
                      <h2 className="text-white tw-text-xl tw-font-semibold">Sell with POD</h2>

                      <p className="tw-text-sm tw-text-faint tw-mt-3">
                        Start selling with POD and get the chance to become a POD Seller Partner
                      </p>

                      <div className="tw-mt-8">
                        {[
                          'Reach more buyers and sell more',
                          'Sell faster',
                          { text: 'Make extra income', extra: ' with commissions from PSP', bold: true }
                        ].map((item, index) => (
                          <div key={index} className="tw-flex tw-items-center tw-gap-4">
                            <img
                              src="/images/icons/icon-right.png"
                              alt="icon-right"
                              style={{ width: '10px', height: '6.66px' }}
                            />
                            <p className="tw-text-sm tw-text-faint tw-mt-4">
                              {typeof item === 'string' ? (
                                item
                              ) : (
                                <>
                                  <span className="tw-font-semibold">{item.text} </span>
                                  {item.extra}
                                </>
                              )}
                            </p>
                          </div>
                        ))}
                      </div>

                      <div className="tw-flex tw-justify-center md:tw-justify-start">
                        <button
                          className="tw-rounded-lg tw-border tw-border-white tw-py-2 tw-px-2.5 tw-mt-8 tw-mr-5"
                          onClick={() => this.learnMore('/psp-seller-learn-more')}>
                          <span className="text-black tw-text-sm tw-font-semibold">learn more</span>
                        </button>
                        <button className="tw-bg-secondary tw-rounded-lg tw-border tw-border-white tw-py-2 tw-px-2.5 tw-mt-8 tw-text-white"
                          onClick={(cta) => this.buttonCTA(cta, '/psp-onboard-signup')}>
                          Start selling &nbsp;&nbsp;
                          <img
                            src="/images/icons/right.svg"
                            alt="shop"
                            className="size-24px"
                          />
                        </button>
                      </div>
                    </div>

                    <div className="tw-md:flex tw-justify-end tw-mb-10 tw-px-10 tw-hidden">
                      <span className="tw-block tw-bg-[#AAD7E1] size-10px tw-rounded-full"></span>
                    </div>
                    <div>
                      <img
                        src="/images/ssp/bg-desktop2.png"
                        alt="bg-desktop"
                        className="tw-w-full tw-h-80 tw-object-cover tw-hidden tw-md:tw-block"
                      />
                      <img
                        src="/images/ssp/bg-mobile2.png"
                        alt="bg-desktop"
                        className="tw-w-full tw-h-28 tw-object-cover tw-md:tw-hidden"
                      />
                    </div>
                  </div>
                ) : (
                  <div
                    className="carded tw-bg-primary tw-pt-3 tw-max-h-[90vh] tw-mb-16 tw-md:mb-0 tw-text-white tw-rounded-3xl tw-overflow-hidden tw-relative">
                    <div className="tw-bg-[#FDAE09] size-55px tw-rounded-full tw-absolute tw-top-[-24px] tw-right-[-10px] tw-hidden tw-md:tw-block"></div>

                    <div className="tw-md:tw-px-12 tw-px-6 tw-py-8 tw-max-h-[70vh] tw-overflow-y-scroll styled-scrollbar">
                      <p className="tw-text-sm tw-text-faint">
                        Welcome to the POD Partnership Program, where your success is
                        our priority! Joining our program opens up a world of
                        opportunities to take your business to new heights. Here's what
                        you need to know:
                      </p>
                      <div className="tw-mt-8">
                        <p className="tw-text-base tw-text-faint tw-mb-6">
                          What is the POD Partnership Program?
                        </p>
                        <p className="tw-text-sm tw-text-faint tw-mt-3">
                          The POD Partnership Program is a unique opportunity for
                          sellers like you to earn additional income by referring
                          businesses to join POD. As they sign up and start selling
                          through POD, you'll earn a percentage of the revenue
                          generated.
                        </p>
                      </div>
                      <div className="tw-mt-12">
                        <p className="tw-text-base tw-text-faint tw-mt-6 tw-mb-6">
                          Why join the POD Partnership Program?
                        </p>
                        {[
                          'Boost Your Earnings: Earn extra income simply by sharing your unique referral link with other businesses.',
                          'Empowerment: Take control of your financial future and unlock new revenue streams.',
                          'Support: Receive dedicated support from the POD team to help you succeed in the program.',
                          'Flexibility: Work at your own pace and fit the program into your existing schedule.'
                        ].map((text, index) => (
                          <div key={index} className={`tw-flex tw-items-center tw-gap-4 ${index > 0 ? 'tw-mt-4' : ''}`}>
                            <span className="tw-block tw-w-1 tw-h-1 tw-bg-faint tw-rounded-full"></span>
                            <p className="tw-text-sm tw-text-faint">
                              {text}
                            </p>
                          </div>
                        ))}
                      </div>

                      <div className="tw-mt-12">
                        <p className="tw-text-base tw-text-faint tw-mt-6 tw-mb-6">
                          How Does it Work?
                        </p>
                        {[
                          'Sign up for the POD Partnership Program.',
                          'Receive your unique referral link.',
                          'Share your link with other businesses.',
                          'Earn a percentage of the revenue generated by the businesses you refer.'
                        ].map((text, index) => (
                          <div key={index} className={`tw-flex tw-items-center tw-gap-4 ${index > 0 ? 'tw-mt-4' : ''}`}>
                            <span className="tw-block tw-w-1 tw-h-1 tw-bg-faint tw-rounded-full"></span>
                            <p className="tw-text-sm tw-text-faint">
                              {text}
                            </p>
                          </div>
                        ))}
                      </div>

                      <div className="tw-mt-6">
                        <p className="tw-text-sm tw-text-faint tw-mt-3">
                          Ready to Get Started? Joining the POD Partnership Program is
                          quick and easy. Simply sign up, start sharing your referral
                          link, and watch your earnings grow! Sign Up Now and Start
                          Earning!
                        </p>
                      </div>
                    </div>

                    <div className="tw-mb-10 tw-px-10">
                      <div className="tw-flex tw-justify-end">
                        <button
                          className="tw-rounded-lg tw-border tw-border-white tw-py-2 tw-px-2.5 tw-mt-8"
                          onClick={() => this.setState({ readMore: !this.state.readMore })}>
                          <span className="tw-text-sm tw-font-semibold">Okay, Got it</span>
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </AppContent>
      </>
    )
  }
}
